export default "__VITE_ASSET__Dj9KA8ro__"